import * as tslib_1 from "tslib";
import { rangesEqual } from '@fullcalendar/core';
import { parseResourceSource, getResourceSourceDef, doesSourceIgnoreRange } from '../structs/resource-source';
export default function (source, action, dateProfile, calendar) {
    switch (action.type) {
        case 'INIT':
            return createSource(calendar.opt('resources'), calendar);
        case 'RESET_RESOURCE_SOURCE':
            return createSource(action.resourceSourceInput, calendar, true);
        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
        case 'NEXT':
        case 'SET_DATE':
        case 'SET_VIEW_TYPE':
            return handleRange(source, dateProfile.activeRange, calendar);
        case 'RECEIVE_RESOURCES':
        case 'RECEIVE_RESOURCE_ERROR':
            return receiveResponse(source, action.fetchId, action.fetchRange);
        case 'REFETCH_RESOURCES':
            return fetchSource(source, dateProfile.activeRange, calendar);
        default:
            return source;
    }
}
var uid = 0;
function createSource(input, calendar, forceFetch) {
    if (input) {
        var source = parseResourceSource(input);
        if (forceFetch || !calendar.opt('refetchResourcesOnNavigate')) { // because assumes handleRange will do it later
            source = fetchSource(source, null, calendar);
        }
        return source;
    }
    return null;
}
function handleRange(source, activeRange, calendar) {
    if (calendar.opt('refetchResourcesOnNavigate') &&
        !doesSourceIgnoreRange(source) &&
        (!source.fetchRange || !rangesEqual(source.fetchRange, activeRange))) {
        return fetchSource(source, activeRange, calendar);
    }
    else {
        return source;
    }
}
function fetchSource(source, fetchRange, calendar) {
    var sourceDef = getResourceSourceDef(source.sourceDefId);
    var fetchId = String(uid++);
    sourceDef.fetch({
        resourceSource: source,
        calendar: calendar,
        range: fetchRange
    }, function (res) {
        // HACK
        // do before calling dispatch in case dispatch renders synchronously
        calendar.afterSizingTriggers._resourcesRendered = [null]; // fire once
        calendar.dispatch({
            type: 'RECEIVE_RESOURCES',
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawResources: res.rawResources
        });
    }, function (error) {
        calendar.dispatch({
            type: 'RECEIVE_RESOURCE_ERROR',
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return tslib_1.__assign({}, source, { isFetching: true, latestFetchId: fetchId });
}
function receiveResponse(source, fetchId, fetchRange) {
    if (fetchId === source.latestFetchId) {
        return tslib_1.__assign({}, source, { isFetching: false, fetchRange: fetchRange });
    }
    return source;
}
